import PropTypes from "prop-types"

import AddressShape from "./AddressShape"
import { SdiraTypeEnumKeys } from "./SdiraTypeEnum"

const properties = {
  accountName: PropTypes.string,
  custodianAddress: AddressShape,
  custodianEinNumber: PropTypes.string,
  custodianId: PropTypes.string,
  custodianName: PropTypes.string,
  einNumber: PropTypes.string,
  entityName: PropTypes.string,
  hasEinNumber: PropTypes.bool,
  hasPurchasedExemptSecurities: PropTypes.bool,
  isLiabilityAccepted: PropTypes.bool,
  profileName: PropTypes.string,
  sdiraType: PropTypes.oneOf(SdiraTypeEnumKeys),
  shouldCustodianSign: PropTypes.bool
}

const SdiraShape = PropTypes.exact(properties)

export default SdiraShape
export { properties }
